/**
 * Skip-region REST API + path resolution.
 *
 * Backend endpoint: /api/item/skip-regions  (POST/PUT/DELETE/GET)
 * Body fields: path, start, end, enabled, label, source, mode, repeat_count, speed.
 */

const srvFetch = (url, opts) =>
  fetch(url, Object.assign({ credentials: 'include' }, opts || {})).then((r) =>
    r.ok ? r.json() : Promise.reject(r.status),
  );

export function srvCreate(rawPath, region) {
  if (!rawPath) return Promise.resolve();
  return srvFetch('/api-zapd/item/skip-regions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      path: rawPath,
      start: region.start,
      end: region.end,
      enabled: region.enabled,
      label: region.label,
      source: 'user',
      mode: region.mode,
      repeat_count: region.repeat_count,
      speed: region.speed,
    }),
  })
    .then((d) => {
      if (d?.data?.region?.id) region.id = d.data.region.id;
    })
    .catch(() => {});
}

export function srvUpdate(rawPath, region) {
  if (!region.id || !rawPath) return Promise.resolve();
  return srvFetch('/api-zapd/item/skip-regions?id=' + region.id, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      start: region.start,
      end: region.end,
      enabled: region.enabled,
      label: region.label,
      mode: region.mode,
      repeat_count: region.repeat_count,
      speed: region.speed,
    }),
  }).catch(() => {});
}

export function srvDelete(id) {
  if (!id) return Promise.resolve();
  return srvFetch('/api-zapd/item/skip-regions?id=' + id, { method: 'DELETE' }).catch(() => {});
}

export function srvList(rawPath) {
  if (!rawPath) return Promise.resolve(null);
  return srvFetch('/api-zapd/item/skip-regions?path=' + encodeURIComponent(rawPath)).catch(
    () => null,
  );
}

/**
 * Resolve canonical /data path from a video element + optional fallback button.
 * Used as identity key for regions/resume — must be stable across page reloads.
 */
export function resolveRawPath(video) {
  const rawSrc = video?.currentSrc || video?.src || '';
  if (rawSrc) {
    try {
      const u = new URL(rawSrc, document.location.origin);
      return u.pathname.startsWith('/media/')
        ? '/data/' + decodeURIComponent(u.pathname.slice(7))
        : decodeURIComponent(u.pathname);
    } catch {
      /* fall through */
    }
  }
  const btn = document.getElementById('btn-play-hls');
  if (btn?.dataset.streamUrl) {
    const dec = decodeURIComponent(btn.dataset.streamUrl);
    return dec.startsWith('/media/') ? '/data/' + dec.slice(7) : dec;
  }
  return '';
}
